import echarts from 'echarts'
import SelectRange from '../SelectRange'

export default {
  components: { SelectRange },
  inject: ['mainProvide'],
  props: {
    chartId: { type: String, default: 'chart' }
  },
  data() {
    return {
      loading: false,
      /**
       * @type {import('../../index.vue').IRoleId}
       */
      roleId: this.$parent.roleId || '',
      /** 查询条件 */
      condition: {}
    }
  },
  watch: {
    mainProvide: {
      handler: function() {
        this.chartIns.resize()
      },
      deep: true
    }
  },
  mounted: function() {
    // console.log('mounted-mixins')
    this.chartIns = echarts.init(document.getElementById(this.chartId))
    let that = this
    let conf = that.conf

    // 默认启用 Series 点击
    // if (typeof conf.triggerClick === 'undefined') conf.triggerClick = true

    if (conf.triggerLabel || conf.triggerClick) {
      this.chartIns.on('click', function(params) {
        // console.log('图表配置：', that.source, conf)
        if (params.targetType === 'axisLabel') {
          if (conf.triggerLabel) {
            let label = (params.event.target.anid || '').split('_')
            // xAxis 下标；每个组件都有 chartData.xAxis
            let p = [label[1], params]
            if (typeof conf.triggerLabel === 'function') {
              conf.triggerLabel(...p)
            } else {
              console.log('公共处理 Label:', p)
            }
          }
        } else {
          if (conf.triggerClick) {
            // data：与 Series 传入的值类型相同
            let p = [params.data, params]
            if (typeof conf.triggerClick === 'function') {
              conf.triggerClick(...p)
            } else {
              console.log('公共处理 Series:', p)
            }
          }
        }
      })
    }
  },
  beforeDestroy() {
    // console.log('beforeDestroy-mixins')
    if (!this.chartIns) {
      return
    }
    this.chartIns.off('click')
    this.chartIns.dispose()
    this.chartIns = null
  },
  methods: {
    getEChartConstructor: function() {
      return echarts
    },
    rangeChange: function(data) {
      console.log('rC: ', data)
      this.getData(data)
    },

    genData: function(count) {
      let makeWord = this.makeWord

      var legendData = []
      var seriesData = []
      for (var i = 0; i < count; i++) {
        var name = Math.random() > 0.65 ? makeWord(2, 1) + '·' + makeWord(1, 0) : makeWord(2, 1)
        legendData.push(name)
        seriesData.push({
          name: name,
          value: this.genVal()
        })
      }

      return {
        legendData: legendData,
        seriesData: seriesData
      }
    },
    // 模拟数据库回来数据
    genTableData: function(count) {
      let list = []
      for (var i = 0; i < count; i++) {
        list.push({
          // 人名
          name: this.getName(),
          // 工程阶段
          stage: this.getStage(),
          value: this.genVal(),
          brand: '品:' + this.makeWord(1, 0),
          city: '城市:' + this.makeWord(1, 1, [-8]),
          time: ['本周', '本月', '本年'][this.genVal(2)]
        })
      }

      return list
    },

    genVal: function(rank = 100) {
      return Math.round(Math.random() * rank)
    },
    /**
     * 构建短语
     * @param {number} max 变化步长
     * @param {number} min 偏移
     * @returns 名字
     */
    makeWord: function(max, min, sliceArg = []) {
      var nameList = [
        '赵',
        '钱',
        '孙',
        '李',
        '周',
        '吴',
        '郑',
        '王',
        '冯',
        '陈',
        '褚',
        '卫',
        '蒋',
        '沈',
        '韩',
        '杨',
        '朱',
        '秦',
        '尤',
        '许',
        '何',
        '吕',
        '施',
        '张',
        '孔',
        '曹',
        '严',
        '华',
        '金',
        '魏',
        '陶',
        '姜',
        '戚',
        '谢',
        '邹',
        '喻',
        '柏',
        '水',
        '窦',
        '章',
        '云',
        '苏',
        '潘',
        '葛',
        '奚',
        '范',
        '彭',
        '郎',
        '鲁',
        '韦',
        '昌',
        '马',
        '苗',
        '凤',
        '花',
        '方',
        '俞',
        '任',
        '袁',
        '柳',
        '酆',
        '鲍',
        '史',
        '唐',
        '费',
        '廉',
        '岑',
        '薛',
        '雷',
        '贺',
        '倪',
        '汤',
        '滕',
        '殷',
        '罗',
        '毕',
        '郝',
        '邬',
        '安',
        '常',
        '乐',
        '于',
        '时',
        '傅',
        '皮',
        '卞',
        '齐',
        '康',
        '伍',
        '余',
        '元',
        '卜',
        '顾',
        '孟',
        '平',
        '黄',
        '和',
        '穆',
        '萧',
        '尹',
        '姚',
        '邵',
        '湛',
        '汪',
        '祁',
        '毛',
        '禹',
        '狄',
        '米',
        '贝',
        '明',
        '臧',
        '计',
        '伏',
        '成',
        '戴',
        '谈',
        '宋',
        '茅',
        '庞',
        '熊',
        '纪',
        '舒',
        '屈',
        '项',
        '祝',
        '董',
        '梁',
        '杜',
        '阮',
        '蓝',
        '闵',
        '席',
        '季',
        '麻',
        '强',
        '贾',
        '路',
        '娄',
        '危'
      ].slice(...sliceArg)
      var nameLen = Math.ceil(Math.random() * max + min)
      var name = []
      for (var i = 0; i < nameLen; i++) {
        let index = Math.round(Math.random() * (nameList.length - 1))
        if (!nameList[index]) console.log(nameList.length, index)
        name.push(nameList[index])
      }
      return name.join('')
    },
    getName: function() {
      let stage = [
        '张三',
        '彬蔚',
        '彬彬',
        '博裕',
        '博闻',
        '博容',
        '博文',
        '博艺',
        '博雅',
        '承德',
        '李四',
        '朝宗',
        '澄泓',
        '存志',
        '澹雅',
        '得韬',
        '德辉',
        '方旭',
        '飞轩',
        '芳华'
      ]
      return stage[Math.floor(Math.random() * stage.length)]
    },
    getStage: function() {
      let stage = ['集成', '待维修', '代采', '改造', '闭店', '开店', '安装', '巡检', '运维']
      return stage[Math.floor(Math.random() * stage.length)]
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/viewBoard/components/mixins/common.js